import { useState } from 'react';

import { FormValues } from '../types';
import { hasAnyPastMonth } from '../utils';

type UseWarningDialogReturn = {
  isOpen: boolean;
  pendingData: FormValues | null;
  checkAndSubmit: (data: FormValues, onDirectSubmit: (data: FormValues) => void) => void;
  confirm: (onSubmit: (data: FormValues) => void) => void;
  close: () => void;
};

export const useWarningDialog = (): UseWarningDialogReturn => {
  const [pendingData, setPendingData] = useState<FormValues | null>(null);

  const isOpen = pendingData !== null;

  const checkAndSubmit = (data: FormValues, onDirectSubmit: (data: FormValues) => void) => {
    const entries = data.dateEntries;

    const hasPastMonth = hasAnyPastMonth(entries);

    if (hasPastMonth) {
      setPendingData(data);
    } else {
      onDirectSubmit(data);
    }
  };

  const confirm = (onSubmit: (data: FormValues) => void) => {
    if (pendingData) {
      onSubmit(pendingData);
      setPendingData(null);
    }
  };

  const close = () => {
    setPendingData(null);
  };

  return { isOpen, pendingData, checkAndSubmit, confirm, close };
};
